import React, {useEffect, useRef, useState} from 'react';
import {ReactComponent as ArrowDownTwoIcon} from '../../../../../assets/main/groups/main-table/arrow-down-two.svg';
import './style.css'
import {Period} from "../../../../../features/model/types/payments/actsSchema";
import {fetchActs} from "../../../../../features/model/service/payments/acts/fetchActs";
import {useAppDispatch} from "../../../../../common/hook";


interface LittleSelectorProps {
    options: Period[];
    title: string
}


export const LittleSelector = ({options, title}: LittleSelectorProps) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const selectorRef = useRef<HTMLDivElement>(null);
    const [selectedOption, setSelectedOption] = useState('Выберите перод');
    const dispatch = useAppDispatch();


    const handleDropdownToggle = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleOptionSelect = (option: string) => {
        setSelectedOption(option);
        setIsDropdownOpen(false);
        dispatch(fetchActs({period: option}));
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (selectorRef.current && !selectorRef.current.contains(event.target as Node)) {
            setIsDropdownOpen(false);
        }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            setIsDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (
        <div className="data-tbl-filter" ref={selectorRef}>
            <span className={'filter-item active'}>
                {title}
            </span>
            <span className={`filter-item ${isDropdownOpen ? 'active position-relative' : ''}`}
                  onClick={handleDropdownToggle}>
                {selectedOption}
                <ArrowDownTwoIcon/>
            </span>
            <div className={`dropdown-menu position-absolute ${isDropdownOpen ? 'visible' : 'hidden'}`}>
                {options.map((option, index) => (
                    <span key={index} className="filter-item" onClick={() => handleOptionSelect(option.label)}>
                        {option.label}
                    </span>
                ))}
            </div>
        </div>
    );
};